import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getHotTopicItemImageUrl } from '../../../utils/hot-topic';
import CardBadge from './cardBadge';
import moment from 'moment';
import { VideoCardTags } from './VideoCardTags';

const useStyles = makeStyles()(theme => ({
  root: {
    height: 'fit-content',
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    background: '#fff',
    fontFamily: 'inherit',
    width: 200,
    margin: '12px 0 8px 8px',
    padding: 0
  },
  headerImage: {
    objectFit: 'cover',
    width: '100%',
    height: 113.5
  },
  CardBadgeContainer: {
    position: 'absolute',
    top: 8,
    left: 0
  },
  // icon: {
  //     fontSize: 40,
  //     marginRight: theme.spacing(2),
  //     background: '#fff',
  //     borderRadius: '50%',
  //     color: '#7C3AED',
  //     padding: 4,
  //     boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  // },
  // badge: {
  //     position: 'absolute',
  //     top: 8,
  //     right: 16,
  //     background: '#6D28D9',
  //     borderRadius: 12,
  //     padding: '2px 12px',
  //     fontSize: 14,
  //     fontWeight: 600,
  // },
  contentBody: {
    background: '#fff',
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 12,
    paddingTop: 10
  },
  titleContainer: {
    width: '100%',
    marginBottom: 4
  },
  title: {
    textAlign: 'left',
    fontSize: 14,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%'
  },
  subtitle: {
    color: '#7C3AED',
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 16
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 12
  },
  tagsContainer: {
    height: 72,
    overflow: 'hidden'
  }
}));

export function VideoCardPortrait({ intl, locale, itemData, onClick, ...props }) {
  const { title, tags } = itemData;
  const thumbnailImageUrl = getHotTopicItemImageUrl(itemData);
  const isRecentlyUpdated = itemData.updatedAt && moment(itemData.updatedAt).isAfter(moment().subtract(14, 'days'));
  const isRecentlyCreated = itemData.createdAt && moment(itemData.createdAt).isAfter(moment().subtract(14, 'days'));
  const isHot = itemData.isHot === true;
  const badge = isRecentlyUpdated
    ? intl.formatMessage({ id: 'hottopic-updated' })
    : isRecentlyCreated
    ? intl.formatMessage({ id: 'hottopic-new' })
    : isHot
    ? intl.formatMessage({ id: 'hot' })
    : undefined;

  const { classes } = useStyles();
  return (
    <Box className={classes.root} {...props.ContainerProps} onClick={onClick}>
      <Box className={classes.CardBadgeContainer}>{badge && <CardBadge label={badge} />}</Box>
      <Box
        className={classes.headerImage}
        style={{
          backgroundImage: `url(${thumbnailImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></Box>
      <Box className={classes.contentBody}>
        <Box className={classes.titleContainer}>
          <Typography className={classes.title}>{title[locale]}</Typography>
        </Box>
        <Box className={classes.tagsContainer}>
          <VideoCardTags locale={locale} tags={tags ? tags : []} usePlaceholder={true} />
        </Box>
      </Box>
    </Box>
  );
}

export default VideoCardPortrait;
